var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.877 22.9102C19.8916 22.9288 19.9102 22.9439 19.9316 22.9543C19.9529 22.9647 19.9763 22.9701 20 22.9701C20.0237 22.9701 20.0471 22.9647 20.0684 22.9543C20.0898 22.9439 20.1084 22.9288 20.123 22.9102L22.3105 20.1426C22.3906 20.041 22.3184 19.8906 22.1875 19.8906H20.7402V13.2812C20.7402 13.1953 20.6699 13.125 20.584 13.125H19.4121C19.3262 13.125 19.2559 13.1953 19.2559 13.2812V19.8887H17.8125C17.6816 19.8887 17.6094 20.0391 17.6895 20.1406L19.877 22.9102ZM27.1484 22.2266H25.9766C25.8906 22.2266 25.8203 22.2969 25.8203 22.3828V25.3906H14.1797V22.3828C14.1797 22.2969 14.1094 22.2266 14.0234 22.2266H12.8516C12.7656 22.2266 12.6953 22.2969 12.6953 22.3828V26.25C12.6953 26.5957 12.9746 26.875 13.3203 26.875H26.6797C27.0254 26.875 27.3047 26.5957 27.3047 26.25V22.3828C27.3047 22.2969 27.2344 22.2266 27.1484 22.2266Z",
    fill: "#0079BA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#0079BA",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.028b64ee4d0580353ff864524aa5aca0.svg";
export { ForwardRef as ReactComponent };